import { styled } from '@mui/material'
import { colors } from '@theme/variables'

export const ButtonContainer = styled('div')`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;

  & :not(:last-child) {
    margin-right: 10px;
  }
`

export const SmallTextMessage = styled('div')`
  margin-top: 10px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: ${colors.bodyText};
`
